import { Form, Input, Spin, Tree } from 'antd'
import { useEffect, useState, useRef } from 'react'
import RoleService from '../../../@services/role'

const permissions2TreeData = data => {
  return (data || []).map(item => {
    item.title = item.name
    item.key = item.id
    if (item.children && item.children.length) {
      item.children = permissions2TreeData(item.children)
    }
    return item
  })
}

const TreeCheck = props => {
  const treeProps = { ...(props || {}) }
  const $tree = useRef(null)
  if (props.value) {
    treeProps.checkedKeys = props.value
  }

  const getParentKeys = (node, checkedKeys) => {
    let keys = []
    if (node.parent) {
      if (!checkedKeys.includes(node.parent.key)) {
        keys.push(node.parent.key)
      }
      keys = keys.concat(getParentKeys(node.parent, checkedKeys))
    }
    return keys
  }

  const getChildrenKeys = (node, checkedKeys) => {
    let keys = []
    if (Array.isArray(node.children)) {
      node.children.forEach(item => {
        if (!checkedKeys.includes(item.key)) {
          keys.push(item.key)
        }
        keys = keys.concat(getChildrenKeys(item, checkedKeys))
      })
    }
    return keys
  }

  const onCheck = (checked, event) => {
    const { keyEntities } = $tree.current.state
    const checkedKeys = checked.checked || []
    const key = event.node.key
    let keys = [...checkedKeys]
    const node = keyEntities[key]
    if (event.checked) {
      keys = keys.concat(getParentKeys(node, keys))
      keys = keys.concat(getChildrenKeys(node, keys))
    } else {
      const noChecked = getChildrenKeys(node, [])
      keys = keys.filter(item => !noChecked.includes(item))
    }
    treeProps.onChange(keys, event)
  }
  return (
    <Spin spinning={treeProps.loading}>
      <Tree {...treeProps} onCheck={onCheck} ref={$tree} />
    </Spin>
  )
}

export default function FormPage(props) {
  const { originForm } = props
  const [form] = Form.useForm(originForm)

  const [treeProps, setTreeProps] = useState({
    treeData: [],
    checkable: true,
    checkStrictly: true,
    autoExpandParent: true,
    loading: false,
  })

  useEffect(() => {
    const getPermissionsTree = async () => {
      try {
        setTreeProps(state => ({ ...state, loading: true }))
        const res = await RoleService.getPermissionsTree()
        setTreeProps(state => ({
          ...state,
          treeData: permissions2TreeData(res),
        }))
      } catch (error) {
        console.log({ error })
      } finally {
        setTreeProps(state => ({ ...state, loading: false }))
      }
    }
    getPermissionsTree()
  }, [originForm])

  return (
    <Form
      form={form}
      initialValues={{ state: true }}
      labelCol={{ span: 4 }}
      wrapperCol={{ span: 18 }}
    >
      <Form.Item name="id" style={{ display: 'none' }}>
        <></>
      </Form.Item>

      <Form.Item
        name="name"
        label="角色名称"
        rules={[{ required: true, message: '请输入角色名称' }]}
      >
        <Input placeholder="请输入角色名称" />
      </Form.Item>
      <Form.Item
        name="permissions"
        label="权限菜单"
        rules={[{ required: true, message: '请选择权限菜单' }]}
      >
        <TreeCheck
          {...treeProps}
          style={{ maxHeight: '200px', overflow: 'auto' }}
        />
      </Form.Item>
      <Form.Item name="description" label="备注">
        <Input.TextArea
          placeholder="请输入备注"
          autoSize={{ minRows: 4, maxRows: 10 }}
        />
      </Form.Item>
    </Form>
  )
}
